import { useTranslation } from 'react-i18next'

/** VH-225: "Does X replace Y?" — the app suggests, the user decides. */
export default function VariantSuggestionPrompt({ suggestion, onConfirm, onReject, busy = false }) {
  const { t } = useTranslation()
  return (
    <div className="border border-blue-300 bg-blue-50 rounded-lg p-3 text-sm" data-testid="variant-suggestion">
      <p>{t('trainingAnalysis.variants.question', { to: suggestion.to_exercise_name, from: suggestion.from_exercise_name })}</p>
      {suggestion.switch_date && (
        <p className="text-xs text-gray-600">{t('trainingAnalysis.variants.since', { date: suggestion.switch_date })}</p>
      )}
      <div className="flex gap-2 mt-2">
        <button type="button" disabled={busy} onClick={() => onConfirm(suggestion)}
          className="px-3 py-1 rounded bg-primary text-white disabled:opacity-50">
          {t('trainingAnalysis.variants.confirm')}
        </button>
        <button type="button" disabled={busy} onClick={() => onReject(suggestion)}
          className="px-3 py-1 rounded border disabled:opacity-50">
          {t('trainingAnalysis.variants.reject')}
        </button>
      </div>
    </div>
  )
}
